var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7398 8.79C22.7398 8.55 22.7098 8.28 22.6498 8.04C22.6198 7.17 22.8598 5.85 24.5998 5.94C24.8698 6.03 25.1698 6.06 25.4698 6.06C27.1498 6.06 28.4998 4.71 28.4998 3.03C28.4998 1.35 27.1198 0 25.4398 0C23.7598 0 22.4098 1.35 22.4098 3.03C22.4098 3.33 22.4398 3.6 22.5298 3.87C22.4998 4.68 21.9598 5.76 19.3798 5.76H4.55979C2.87979 5.76 1.52979 7.11 1.52979 8.79C1.52979 11.4 3.65979 11.82 3.65979 11.82C4.49978 11.82 5.18978 12.51 5.18978 13.35C5.18978 14.19 4.49978 14.88 3.65979 14.88C3.65979 14.88 1.52979 15.24 1.52979 17.91C1.52979 19.59 2.87979 20.94 4.55979 20.94H13.6498C15.3298 20.94 16.6798 19.59 16.6798 17.91C16.6798 16.23 15.2998 14.85 13.6498 14.85H8.18978C7.34978 14.85 6.65978 14.16 6.65978 13.32C6.65978 12.48 7.34978 11.79 8.18978 11.79H19.7098C21.3598 11.82 22.7398 10.47 22.7398 8.79ZM5.75979 23.94C4.07979 23.94 2.72979 25.29 2.72979 26.97C2.72979 28.65 4.07979 30 5.75979 30C7.43979 30 8.78978 28.65 8.78978 26.97C8.78978 25.29 7.43979 23.94 5.75979 23.94Z",
    fill: "url(#paint0_linear_4719_52860)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4719_52860",
    x1: 14.9998,
    y1: 30,
    x2: 14.9998,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA3F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01BAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/Logo-small.f5fd72c2b90692f58a2ca78a8fbb736a.svg";
export { ForwardRef as ReactComponent };